let gallery = null;

/**
 * load app to show responsive gallery
 * @param {boolean} shouldCreateGallery control if we need to create or destroy the application
 * @return {Promise<void>}
 */
async function loadResponsiveGallery(shouldCreateGallery) {
	if (shouldCreateGallery) {
		const { createGallery } = await import('./main.js');
		gallery = await createGallery();
	}
	else {
		gallery?.$destroy();
		gallery = null;
	}
}

const mobileBreakpoint = window.matchMedia('(max-width: 991.98px)');
mobileBreakpoint.addEventListener('change', ({ matches }) => loadResponsiveGallery(matches));
void loadResponsiveGallery(mobileBreakpoint.matches);
